import * as React from "react";
import { DateSelect } from "../../atoms/forms/DateSelect";
import { ICommonControlWithMinMax } from "./ICommonInputsControls";
import { useTranslation } from 'react-i18next';

// All the incoming values
interface IProps {

}

// Outgoing functions
interface IDispatch {

}

// Actual Component
export type AllProps = IProps & IDispatch & ICommonControlWithMinMax<Date>;
export const ContactDateSelect = (props: AllProps) => {
    const { t: tDatatypes } = useTranslation('datatypes');

    
    const label = props.label || tDatatypes('contactDatumLabel') || "Contactdatum";      

    return (<DateSelect
        {...props}

        label={label}
        placeholder={tDatatypes('contactDatumPlaceholder')}

         />)
}